module.exports = __webpack_public_path__ + "static/media/gallery_01_t.63b5bcb0.jpg";